import {
  ADMIN_FINANCIAL_PRODUCT_READ,
  ADMIN_FINANCIAL_PRODUCT_WRITE,
  ADMIN_GENERIC_FILTER_PARAMS_READ,
  ADMIN_GENERIC_FILTER_TEMPLATES_READ,
  ADMIN_GENERIC_FILTER_TEMPLATES_WRITE
} from 'constants/rightsCodes';

export const TransferFileType = {
  Json: 'Json'
};

/**
 * Entity configuration routes type definition
 * @typedef {Object} EntityConfigurationRoutes
 * @property {string} import - Indicates the route the user has to be on to display the import action
 * @property {string} export - Indicates the route pattern the user has to be on to display the export action
 * @property {string} redirect - Indicates the route of redirection to the newly created entity after import (should include '{ID}' at the id's place)
 *
 * Entity configuration permissions type definition
 * @typedef {Object} EntityConfigurationPermissions
 * @property {string[]} import - Indicates the permissions needed for the import action
 * @property {string[]} export - Indicates the permissions needed for the export action
 *
 * Entity configuration type definition
 * @typedef {Object} EntityConfiguration
 * @property {string} name - Indicates the name of the entity (IMPORTANT: must correspond to the entity name in the worker)
 * @property {EntityConfigurationRoutes} routes - Indicates the routes where corresponding actions will be shown at
 * @property {string} idParamName - Indicates the id parameter name in the route pattern (defaults to 'id' if not specified)
 * @property {EntityConfigurationPermissions} permissions - Indicates the permissions required to show the actions
 */

/** @type {EntityConfiguration[]} */
export const entityConfigurations = [
  {
    name: 'GenericFilterTemplate',
    routes: {
      import: '/genericFilterTemplates',
      export: '/genericFilterTemplates/:id([+\\-]?\\d+)',
      redirect: '/genericFilterTemplates/{ID}'
    },
    permissions: {
      import: [ADMIN_GENERIC_FILTER_TEMPLATES_WRITE],
      export: [ADMIN_GENERIC_FILTER_TEMPLATES_READ]
    }
  },
  {
    name: 'GenericFilterParam',
    routes: {
      export: '/genericFilterParams/:id([+\\-]?\\d+)'
    },
    permissions: {
      export: [ADMIN_GENERIC_FILTER_PARAMS_READ]
    }
  },
  {
    name: 'FinancialProduct',
    routes: {
      import: '/financialProducts',
      export: '/financialProducts/:id([+\\-]?\\d+)',
      redirect: '/financialProducts/{ID}'
    },
    permissions: {
      import: [ADMIN_FINANCIAL_PRODUCT_WRITE],
      export: [ADMIN_FINANCIAL_PRODUCT_READ]
    }
  }
];
